import * as React from "react";
// @ts-expect-error - TS2305 - Module '"react-router-dom"' has no exported member 'ContextRouter'.
import {Route, type ContextRouter} from "react-router-dom";

import RouteLoadSpinner from "#app-shell-package/route-load-spinner.tsx";
import withUserProfile, {
    type WithoutUserProfile,
    type WithUserProfileProps,
} from "#data-access/with-user-profile.tsx";

import AccessDenied from "./content-pages/access-denied.tsx";
import Error from "./content-pages/error.tsx";
import {profilePathIsMine} from "./content-pages/profile-util.ts";

type RouteProps = JSX.LibraryManagedAttributes<
    typeof Route,
    React.ComponentProps<typeof Route>
>;

type Props = RouteProps & {
    render: (router: ContextRouter) => React.ReactNode;
} & WithUserProfileProps;

// Restricted routes are routes that are only available by you.
// You cannot visit restricted routes for other users
class RestrictedRoute extends React.Component<Props> {
    render(): React.ReactNode {
        const {profile, profileLoading, profileError, ...restProps} =
            this.props;

        const render = (props: ContextRouter) => {
            if (profileLoading) {
                return <RouteLoadSpinner />;
            }

            if (profileError) {
                return <Error />;
            }

            if (!profilePathIsMine(profile, props.location)) {
                return <AccessDenied />;
            }

            return this.props.render(props);
        };

        return <Route {...restProps} render={render} />;
    }
}

type ExportProps = WithoutUserProfile<
    JSX.LibraryManagedAttributes<
        typeof RestrictedRoute,
        React.ComponentProps<typeof RestrictedRoute>
    >
>;

export default withUserProfile(
    RestrictedRoute,
) as React.ComponentType<ExportProps>;
